import { render, staticRenderFns } from "./admin-inactive-2026.vue?vue&type=template&id=1acf88dd&scoped=true"
import script from "./admin-inactive-2026.vue?vue&type=script&lang=js"
export * from "./admin-inactive-2026.vue?vue&type=script&lang=js"
import style0 from "./admin-inactive-2026.vue?vue&type=style&index=0&id=1acf88dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf88dd",
  null
  
)

export default component.exports